import React from "react";
import { Grid, Card, CardContent, Box, CardMedia } from "@mui/material";
import OrgaBF from "./OrgaImages/orga-img-b.jpeg";
import OrgaAF from "./OrgaImages/orga-img-a.jpeg";
import "./orga-check.css";
import Orga01 from "./PptImages/org1.svg";
import Orga02 from "./PptImages/org2.svg";
import Orga03 from "./PptImages/org3.svg";
import Orga04 from "./PptImages/org4.svg";
import Orga05 from "./PptImages/org5.svg";
import { Helmet, HelmetProvider } from "react-helmet-async";
export default function OrgaCheck() {
	return (
		<div className="beratung_cont">
			<HelmetProvider>
				<Helmet>
					<title>Orga Check-Konzept der Feingeist Beratung</title>
					<meta
						name="description"
						content="Orga Check-Konzept der Feingeist Beratung"
					/>
					<meta
						name="keywords"
						content="Orga, Check-Konzept, Beratung, Feingeist, Berlin"
					/>
				</Helmet>
			</HelmetProvider>
			<div className="box-shadow-cont">
				<h1>Das Orga Check-Konzept der Feingeist Beratung</h1>
				<p>
					Mit dem innovativen Orga Check-Konzept entwickeln wir Ihre
					Immobilienverwaltung in kurzer Zeit signifikant weiter.
				</p>

				<p>
					Wir nehmen Ihre Prozesse vor Ort auf, um daraus ein Konzept für die
					nächsten Jahre zu entwickeln. Pragmatisch und individuell auf Sie
					zugeschnitten.
				</p>
				<p>
					Damit heben wir die Synergien in Ihrem Unternehmen. Dabei geht es
					sowohl und die kleinen Verbesserungen als auch um die großen
					Veränderungen.{" "}
				</p>

				<p>
					Die Summe der Verbesserung führt zu einer zukunftsgesicherten
					Immobilienverwaltung.
				</p>
				<hr />
				<Box className="orga-section">
					<h2 className="p-4 text-center">Typische Situation</h2>
					<Grid container spacing={4} justifyContent="space-between">
						<Grid item xs={12} md={5}>
							<Card className="orga-card">
								<CardMedia
									component="img"
									image={OrgaBF}
									title="OrgaBefore"
									className="orga-images"
								/>

								<CardContent className="orga-card-content">
									<h2 className="card-header-text">
										Häufiger Status quo in Immobilienverwaltungen
									</h2>

									<hr className="org-hr" />
									<ul className="typeset-u-list">
										<li>
											<p className="li-text">Fehlende Zuständigkeiten</p>
										</li>
										<li>
											<p className="li-text">
												Keine definierten oder ineffiziente Prozesse
											</p>
										</li>
										<li>
											<p className="li-text">Doppelarbeiten</p>
										</li>
										<li>
											<p className="li-text">Hohe Papierlastigkeit</p>
										</li>
										<li>
											<p className="li-text">
												Schnittstellenbrüche (technisch und organisatorisch)
											</p>
										</li>
										<li>
											<p className="li-text">
												Veraltete lückenhafte oder nicht passende
												Softwarelandschaft / Applikationen
											</p>
										</li>
									</ul>
								</CardContent>
							</Card>
						</Grid>
						<Grid
							item
							md={2}
							alignSelf="center"
							textAlign="center"
							className="arrow-container"
						>
							<div className="arrow-right border-arrow"></div>
						</Grid>
						<Grid item xs={12} md={5}>
							<Card className="orga-card">
								<CardMedia
									component="img"
									image={OrgaAF}
									title="OrgaAfter"
									className="orga-images"
								/>
								<CardContent className="orga-card-content px-4">
									<h2 className="card-header-text">Orga Check-Konzept</h2>

									<hr className="org-hr" />
									<ul className="typeset-u-list">
										<li>
											<p className="li-text">
												Definierte und bestmöglich automatisierte Prozesse
											</p>
										</li>
										<li>
											<p className="li-text">
												Ineinandergreifende papierarme Prozesslandschaft
											</p>
										</li>
										<li>
											<p className="li-text">
												Organisationsaufbau der die Präferenzen der Mitarbeiter
												berücksichtigt
											</p>
										</li>
										<li>
											<p className="li-text">
												Neuster Stand der Technik unter Berücksichtigung der
												Bordmittel
											</p>
										</li>
										<li>
											<p className="li-text">
												Einheitlicher Teamspirit mit Aufbruchstimmung
											</p>
										</li>
									</ul>
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</Box>
			</div>
			<div className="box-shadow-cont">
				<h1>Die Herausforderung</h1>
				<ul className="typeset-u-list">
					<li>
						<p className="li-text">
							Die intensive Einbindung in das Tagesgeschäft lässt der
							Geschäftsführung von Immobilienunternehmen häufig keine
							Kapazitäten die – oftmals auch kundenbezogene unterschiedliche
							Handhabung – der Prozesse zu optimieren.
						</p>
					</li>
					<li>
						<p className="li-text">
							Nur die wenigsten Immobilienunternehmen haben einen
							Verantwortlichen für die Digitalisierung und die
							Organisationsprozesse. Um auch zukünftig erfolgreich am Markt zu
							agieren, müssen Prozesse optimal aufgestellt und über den gesamten
							Bestand vereinheitlicht sein.
						</p>
					</li>
				</ul>
				<div className="sub-pt px-5 font-text">
					<h3 className="py-2">Ihr Vorteil einer Prozessoptimierung ist:</h3>

					<ul className="typeset-u-list">
						<li>
							<p className="li-text">die Kosten zu senken</p>
						</li>
						<li>
							<p className="li-text">neue Erlösquellen zu generieren</p>
						</li>
						<li>
							<p className="li-text">die Kundenzufriedenheit zu heben</p>
						</li>
						<li>
							<p className="li-text">die Mitarbeiter zu entlasten</p>
						</li>
						<li>
							<p className="li-text">das Image zu verbessern</p>
						</li>
					</ul>
				</div>
				<ul className="typeset-u-list">
					<li>
						<p className="li-text">
							Durch langjährige Erfahrung können wir Ihre Prozesse schnell
							optimieren.
						</p>
					</li>
				</ul>
			</div>

			<div className="box-shadow-cont">
				<h2 className="py-4">
					Ihre Verbesserungen durch das Orga Check-Konzept:
					<hr className="org-hr" />
				</h2>

				<div className="konzept-boxes d-flex flex-column">
					<div className="kozept-box d-flex flex-row">
						<div className="konzept-cont konzept-images org-bg-box">
							<img src={Orga01} height="auto" width="100%" />
						</div>
						<div className="konzept-cont kozept-desc d-flex justify-content-between flex-column">
							<h3 className="">Potentialnutzung</h3>
							<p>
								Scan der Verträge nach Umsatzpotential und Anlage von
								entsprechenden Organisations- und Abrechnungsprozessen, Check
								der aktuell definierten Prozesse
							</p>
						</div>
					</div>
					<hr className="org-hr" />
					<div className="kozept-box d-flex flex-row">
						<div className="konzept-cont konzept-images org-bg-box">
							<img src={Orga02} height="auto" width="100%" />
						</div>
						<div className="konzept-cont kozept-desc d-flex justify-content-between flex-column">
							<h3 className="">Organisations prozesse</h3>
							<p>
								Effizientere Bearbeitung von Standard-prozessen wie z.B.:
								Rechnungserfassungsprozess, Posteingangsprozess, Kündigung,
								Neuvermietung, Abnahme, Übergabe, Mieterhöhung, Schadensmeldung,
								Mietvertragsdurchführung etc.
							</p>
						</div>
					</div>
					<hr className="org-hr" />
					<div className="kozept-box d-flex flex-row">
						<div className="konzept-cont konzept-images org-bg-box">
							<img src={Orga03} />
						</div>
						<div className="konzept-cont kozept-desc d-flex justify-content-between flex-column">
							<h3 className="">
								Arbeitsumfeld Mensch und Technologie/ Künstliche Intelligenz
								(KI)
							</h3>
							<p>
								Optimierung der Prozesse durch Verzahnung von Mensch und
								Technologie bspw. durch softwaregestützte Vorgangs-bearbeitung,
								Künstliche Intelligenz (KI)
							</p>
						</div>
					</div>
					<hr className="org-hr" />
					<div className="kozept-box d-flex flex-row">
						<div className="konzept-cont konzept-images org-bg-box">
							<img src={Orga04} />
						</div>
						<div className="konzept-cont kozept-desc d-flex justify-content-between flex-column">
							<h3 className="">Ablagesysteme</h3>
							<p>
								Beratung zur Integration und Umsetzung eines
								Dokumenten-managementsystems (DMS) mit digitalem Posteingang.
							</p>
						</div>
					</div>
					<hr className="org-hr" />
					<div className="kozept-box d-flex flex-row">
						<div className="konzept-cont konzept-images org-bg-box">
							<img src={Orga05} />
						</div>
						<div className="konzept-cont kozept-desc d-flex justify-content-between flex-column">
							<h3 className="">Informations systeme</h3>
							<p>
								Aufzeigen und Beratung bezüglich möglicher anwendbarer
								Software-lösungen und Verzahnung zu anderen Programmen (ERP,
								CRM, DMS, Portal, etc.)
							</p>
						</div>
					</div>
				</div>
				<ul className="typeset-u-list "></ul>
			</div>
		</div>
	);
}
